exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".languages[data-v-36f153a0]{width:100%;text-align:center;margin-bottom:4px}", ""]);

// exports
